<div class="relative w-full" [class.disabled]="disabled">
    <div class="input input-bordered w-full px-3 py-2 rounded border focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white flex items-center justify-between"
        [class.border-red-500]="invalid" [class.border-gray-300]="!invalid" (click)="!disabled && toggleDropdown()">
        <div class="flex items-center">
            <lucide-icon *ngIf="selectedOption" [name]="getIcon(selectedOption!)"
                class="w-4 h-4 mr-2 text-gray-500"></lucide-icon>
            <span>{{ selectedOption || placeholder }}</span>
        </div>
        <lucide-icon name="chevron-down" class="w-4 h-4 text-gray-500 transition-transform"
            [class.rotate-180]="isOpen"></lucide-icon>
    </div>
    <div *ngIf="isOpen" class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
        <div *ngFor="let option of options" class="flex items-center px-3 py-2 cursor-pointer hover:bg-blue-50"
            (click)="selectOption(option)">
            <lucide-icon [name]="getIcon(option)" class="w-4 h-4 mr-2 text-gray-500"></lucide-icon>
            <span>{{ option }}</span>
        </div>
    </div>
</div>
